import { CryptoRepository } from 'common/repositories/index';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', 'Util'];

class CryptoTransactionsController {

    constructor($scope, Util) {

        $scope.transactions = CryptoRepository.getAll('transactions') || [];

        const onCryptoDataNext = () => {

            $scope.transactions = CryptoRepository.getAll('transactions') || [];

            $scope.transactions.forEach((transaction) => {

                const formattedDate = new Date(transaction.timestamp * 1000);

                transaction.value = Util.toFixed(transaction.value, 6);
                transaction.date = moment(formattedDate).format('L');
                transaction.hour = moment(formattedDate).format('LT');

            });

        };

        this.cryptoRepository = CryptoRepository.getObservable();
        this.cryptoSubscriber = this.cryptoRepository
            .subscribe(
                data => onCryptoDataNext(data),
                () => { },
                () => { },
            );

    }

}


class CryptoTransactionsDirective {

    constructor() {

        this.template = require('./crypto-transactions.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, Util) =>
            new CryptoTransactionsController($scope, Util));
        this.controller = _controllerDependencies;
        this.controllerAs = 'CryptoTransactionsCtrl';

    }

}

_directiveDependencies.push(() => new CryptoTransactionsDirective());


angular.module('directives')
    .directive('cryptoTransactions', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/crypto-transactions/crypto-transactions.js